import React from "react";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts";

const GrowthRateChart = ({ data, days, isLoading, onDaysChange }) => {
  const CustomGrowthTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      const growthRate = payload[0].value;
      const date = payload[0].payload.date;
      return (
        <div style={{ backgroundColor: "#fff", padding: "10px", border: "1px solid #ccc", borderRadius: "4px" }}>
          <p style={{ margin: 0, fontWeight: "bold" }}>{label}</p>
          {date && <p style={{ margin: "4px 0", fontSize: "12px", color: "#666" }}>{date}</p>}
          <p style={{ margin: "4px 0", color: growthRate >= 0 ? "#4caf50" : "#f44336" }}>
            Growth Rate: {growthRate >= 0 ? "+" : ""}{growthRate.toFixed(2)}%
          </p>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="chart-card">
      <div className="chart-header">
        <div className="chart-header-with-select">
          <div>
            <h3>Traffic Growth Rate</h3>
            <p>Day-over-day percentage change in visits</p>
          </div>
          <select
            className="days-selector"
            value={days}
            onChange={onDaysChange}
          >
            <option value={7}>Last 7 Days</option>
            <option value={10}>Last 10 Days</option>
            <option value={15}>Last 15 Days</option>
            <option value={30}>Last 30 Days</option>
          </select>
        </div>
      </div>
      <div className="chart-container" style={{ position: 'relative' }}>
        {isLoading && (
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 10
          }}>
            <div className="spinner" style={{ width: '32px', height: '32px' }}></div>
          </div>
        )}
        <ResponsiveContainer width="100%" height={300}>
          <LineChart data={data}>
            <CartesianGrid strokeDasharray="3 3" stroke="#e0e0e0" />
            <XAxis dataKey="day" stroke="#666" />
            <YAxis stroke="#666" label={{ value: '%', position: 'insideLeft' }} />
            <Tooltip content={<CustomGrowthTooltip />} />
            <Legend />
            <Line
              type="monotone"
              dataKey="growthRate"
              stroke="#9c27b0"
              strokeWidth={3}
              name="Growth %"
              dot={{ fill: "#9c27b0", r: 5 }}
              activeDot={{ r: 7 }}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default GrowthRateChart;
